import moment from "moment";
import Cookie from "js-cookie";
import { CheckCodeRepeat, CheckPasswordRepeat, GetMaxCode } from "@/api/rms86/common";
import router from "@/router";
import store from "@/store";
import { dynamicRouteComponent } from "@/store/tab"

export default {
  // 时间戳格式转化
  dateFormat: function (row, column) {
    var date = row[column.property];
    if (date === undefined || date === null) {
      return "";
    }
    return moment(date).format("YYYY-MM-DD HH:mm:ss");
  },
  hardCodeId: function (name) {
    // 处理动态路由多语言拼接
    if (name == "donald"){
      return '5';
    } else if (name == "sam") {
      return '15';
    } else if (name == "hgz") {
      return '13';
    } else if (name == "jun") {
      return '4';
    }
    return "";
  },
}
export function TagFormat(value) {
  if (value === undefined || value === null || value === "") {
    return "";
  }
  return moment(value).format("YYYY-MM-DD HH:mm:ss");
}
// 表单重置
export function resetForm(refName) {
  if (this.$refs[refName]) {
    this.$refs[refName].resetFields();
  }
}
// 邮箱
export function validEmail(email) {
  const reg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/
  return reg.test(email)
}
// 验证是否为手机设备
export function IsMobile() {
  let flag = navigator.userAgent.match(/(Macintosh|phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
  return window.innerWidth>=1024?null:flag;
}
// 讀取用戶角色類型
export function Get_user_type() {
  let flag = JSON.parse(Cookie.get("user_type"));
  return flag;
}
// 讀取用戶id
export function Get_sys_user_id() {
  let flag = Cookie.get("sys_user_id");
  return flag;
}
export function Get_sys_user_name() {
  var flag = Cookie.get("sys_user_name");
  if(flag != null){
    flag = decodeURI(flag);
  }
  return flag;
}
// 讀取登錄類型
export function Get_login_clock() {
  let flag = Cookie.get("login_clock");
  return flag;
}
// 校验编码是否重复
// actione_type: 新增还是修改; sTableName:表名; sId:当前id; sFieldName:字段名 sValue:比较值 sWhere:其他条件 message:动态提示内容
export async function IsCodeRepeat(
  actione_type,
  sTableName,
  sId,
  sFieldName,
  sValue,
  sWhere,
  message,
) {
  var result = new Promise(async (resolve, rejects) => {
    // 调用api接口
    await CheckCodeRepeat({
      params: {
        actione_type: actione_type,
        sTableName: sTableName,
        sId: sId,
        sFieldName: sFieldName,
        sValue: sValue,
        sWhere: sWhere,
      },
    }).then(async (data) => {
      if (data.success === 1 && data.data === true) {
        this.$message.error({
          message: `${this.$t("_content_repeat_re_input")}${message != "" ? "[" + message + "]" : ""
            }`,
        });
        return resolve(false);
      } else if (data.success === 0) {
        this.$message.error(data.message);
        return resolve(false);
      } else {
        return resolve(true);
      }
    })
      .catch((err) => {
        return rejects(err);
      });
  });
  return result;
}

// 校验密码是否重复
export async function IsPasswordRepeat(
  actione_type,
  sId,
  sValue,
  sWhere,
  message,
) {
  var result = new Promise(async (resolve, rejects) => {
    // 调用api接口
    await CheckPasswordRepeat({
      params: {
        actione_type: actione_type,
        sId: sId,
        sValue: sValue,
        sWhere: sWhere,
      },
    }).then((data) => {
      if (data.success === 1 && data.data === true) {
        this.$message.error({
          message: `输入内容重复,请重新输入${message != "" ? "[" + message + "]" : ""
            }`,
        });
        return resolve(false);
      } else if (data.success === 0) {
        this.$message.error(data.message);
        return resolve(false);
      } else {
        return resolve(true);
      }
    })
      .catch((err) => {
        return rejects(err);
      });
  });
  return result;
}

// 获取最大编码
export async function Get_max_code(sTableName, sLookupType = "", sWhere = "", cate_id = 0) {
  var code = await GetMaxCode({
    params: {
      sTableName: sTableName,
      sLookupType: sLookupType,
      sWhere: sWhere,
      cate_id: cate_id,
    },
  }).then(async (data) => {
    // 编码重复时提示
    if (data.success === 1) {
      return data.data;
    } else {
      this.$message.error(data.message);
      return false;
    }
  });
  return code;
}

// 打開頁面並跳轉
export function Open_Tab(close_name, label, actione_type, id, sTable_name, LookupType, fromEle) {
  if (actione_type === "edit" && id === 0) {
    this.$message.error({
      message: this.$t("_select_current_row")
    });
    return false;
  }
  store.commit("get_tab_code", "")
  // 处理动态路由多语言拼接
  if (actione_type === "add")
    store.commit("get_tab_code", label + "[_new]");
  else if (actione_type === "edit")
    store.commit("get_tab_code", label + "[_edit]");
  else if (actione_type === "V")
    store.commit("get_tab_code", label + "[_view]");

  var fromTab = fromEle.$route.name;

  store.commit("selectMenu", { item: { name: close_name, label: label, params: { actione_type: actione_type, id: id, sTable_name: sTable_name, LookupType: LookupType } }, type: 1 })
  router.push({ name: close_name, params: { actione_type: actione_type, id: id, sTable_name: sTable_name, LookupType: LookupType, fromRouter: fromTab } });
  store.dispatch('delCachedView', { name: close_name })
}
// 新增、修改頁面跳轉封裝
export function Push_load(close_name, label, actione_type, id, sTable_name, LookupType) {
  if (actione_type === "edit" && id === 0) {
    this.$message.error({
      message: this.$t("_select_current_row")
    });
    return false;
  }
  // 每次操作先關閉當前列表tab(后续可能无需关闭)
  store.commit("closeTag", { item: { name: this.$route.name } });
  store.commit("get_tab_code", "")
  // 处理动态路由多语言拼接
  if (actione_type === "add")
    store.commit("get_tab_code", label + "[_new]");
  else if (actione_type === "edit")
    store.commit("get_tab_code", label + "[_edit]");
  else if (actione_type === "V")
    store.commit("get_tab_code", label + "[_view]");
  //store.commit("closeTag", { name: close_name });
  store.commit("addNewRoute", { name: close_name, label: label, params: { actione_type: actione_type, id: id, sTable_name: sTable_name, LookupType: LookupType } });
  router.push({ name: close_name, params: { actione_type: actione_type, id: id, sTable_name: sTable_name, LookupType: LookupType, fromRouter: this.$route.name } });
  store.dispatch('delCachedView', { name: close_name })
}
// 保存後跳轉處理
export function Save_push(name, label) {
  // 關閉選項卡
  store.commit("closeTag", { item: { name: this.$route.name } });
  // 跳转至列表页
  router.push({ name: name });

  // 更新麵包屑
  var item = { name: name, path: name, label: label }
  store.commit("selectMenu", { item: item })
  store.commit("get_current_label", label);
}


// 遮罩層顯示
export function showloading() {
  this.$loading({
    lock: true,
    background: 'rgba(0, 0, 0, 0.4)',
  });
}
// 遮罩層隱藏
export function hideloading() {
  const loading = this.$loading({
    lock: true,
    background: 'rgba(0, 0, 0, 0.4)',
  });
  loading.close();
}
// 用於處理sv-icon相關校驗
export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}
//時間加上分鍾數:如 06：01轉化為06:02
export function add_minute(time1, increment_minute) {
  if (time1 == undefined || time1 == "") {
    return;
  }
  if (increment_minute == undefined || increment_minute == "") {
    //為空時默認加1分鍾
    increment_minute = 1;
  }
  var sResult = "";
  var hour = parseInt(time1.split(':')[0]);
  var minute = parseInt(time1.split(':')[1]) + increment_minute;
  if (parseInt(minute) >= 60) {
    var increment_hour = parseInt(minute / 60);
    minute = minute % 60;//餘數
    hour = hour + increment_hour;
    if (parseInt(hour) >= 24) {
      hour = hour - 24;
      sResult = "0";
    }
  }
  // hour 補 0
  if (parseInt(hour) < 10) {
    sResult = (sResult === "0" ? (sResult + hour) : (sResult + "0" + hour));
  }
  else {
    sResult = sResult + hour;
  }
  sResult = sResult + ":";
  // minute 補 0
  if (parseInt(minute) < 10) {
    sResult = (sResult === "0" ? (sResult + minute) : (sResult + "0" + minute));
  }
  else {
    sResult = sResult + minute;
  }
  return sResult;
}
//獲取時間差, 返回分鍾數
export function GetDateDiff(startTime, endTime) {
  var sTime = new Date(startTime);
  var eTime = new Date(endTime);
  var millisecond = parseInt(eTime.getTime() - sTime.getTime());
  var result = millisecond / parseInt(1000 * 60);
  return result;
}
// 非空校驗(處理多語言切換翻譯問題)
export function formValid(message) {
  var validate = (rule, value, callback) => {
    //兑换类型规则
    if (value === "") {
      callback(new Error(message));
    }
    callback();
  }
  return validate;
}
// 全局字體樣式更新
export function SetFontSize(size) {
  var curren_size = "";
  if (size === "Small")
    curren_size = "16px";
  else if (size === "Medium")
    curren_size = "18px";
  else
    curren_size = "20px";
  var span = document.getElementsByTagName("span");
  var table = document.getElementsByTagName("table");
  var h3 = document.getElementsByTagName("h3");
  var li_number = document.querySelectorAll('.number');
  var p = document.getElementsByTagName("p");
  var label = document.getElementsByClassName("el-form-item__label");
  var checkbox = document.getElementsByClassName("el-checkbox__label");
  var dropdown = document.getElementsByClassName("el-dropdown-menu__item");
  var checkbox_text = document.getElementsByClassName("checkbox_text");
  var tag = document.getElementsByClassName("el-tag--small");
  var input = document.getElementsByClassName("el-input__inner");
  var input2 = document.getElementsByClassName("el-range-input");
  var dialog = document.getElementsByClassName("el-dialog__title");
  var textarea = document.getElementsByClassName("el-textarea__inner");
  var formitem = document.getElementsByClassName("el-form-item__content");
  for (var i = 0; i < span.length; i++) {
    if(ignoreClass(span[i]) == false)
      setSizeByClass(span[i], curren_size);
  }
  for (var i = 0; i < table.length; i++) {
    if(ignoreClass(table[i]) == false)
      table[i].style.fontSize = curren_size;
  }
  for (var i = 0; i < h3.length; i++) {
    if(ignoreClass(h3[i]) == false)
      h3[i].style.fontSize = curren_size;
  }
  for (var i = 0; i < li_number.length; i++) {
    if(ignoreClass(li_number[i]) == false)
      li_number[i].style.fontSize = curren_size;
  }
  for (var i = 0; i < p.length; i++) {
    if(ignoreClass(p[i]) == false)
      setSizeByClass(p[i], curren_size);
  }
  for (var i = 0; i < label.length; i++) {
    if(ignoreClass(label[i]) == false)
      setSizeByClass(label[i], curren_size);
  }
  for (var i = 0; i < checkbox.length; i++) {
    checkbox[i].style.fontSize = curren_size;
  }
  for (var i = 0; i < dropdown.length; i++) {
    dropdown[i].style.fontSize = curren_size;
  }
  for (var i = 0; i < checkbox_text.length; i++) {
    checkbox_text[i].style.fontSize = curren_size;
  }
  for (var i = 0; i < tag.length; i++) {
    tag[i].style.fontSize = curren_size;
  }
  for (var i = 0; i < input.length; i++) {
    if(ignoreClass(input[i]) == false)
      input[i].style.fontSize = curren_size;
  }
  for (var i = 0; i < input2.length; i++) {
    input2[i].style.fontSize = curren_size;
  }  
  for (var i = 0; i < dialog.length; i++) {
    dialog[i].style.fontSize = curren_size;
  }
  for (var i = 0; i < textarea.length; i++) {
    textarea[i].style.fontSize = curren_size;
  }
  for (var i = 0; i < formitem.length; i++) {
    formitem[i].style.fontSize = curren_size;
  }
}
function setSizeByClass(element, curren_size) {
  var iSize = parseInt(curren_size);
  if (element._prevClass == "small2") {
    iSize -= 2;
  }
  else if (element._prevClass == "big2") {
    iSize += 2;
  }
  element.style.fontSize = iSize + "px";
}

function ignoreClass(dom1) {
  var tDom = dom1;
  if(tDom && tDom.className && tDom.className.indexOf("NoSetSize") != -1){ return true; }
  while (tDom && (tDom.className || "").indexOf("el-main") == -1) {
    tDom = tDom.parentNode;
    if(tDom && (tDom.className || "").indexOf("NoSetSize") != -1){ return true;}
  }
  return false;
}

//動態加載js
export function loadScript(jsScriptUrl, targetWindow) {
  return new Promise(function (resolve) {
    var startAt = new Date().getTime();
    if (!targetWindow) targetWindow = window;
    if (!Array.from(targetWindow.document.getElementsByTagName('script')).some(function (p) {
      return p.src.includes(jsScriptUrl);
    })) {
      var scriptTag = targetWindow.document.createElement('script');
      scriptTag.type = 'text/javascript';
      scriptTag.src = jsScriptUrl;
      scriptTag.onload = function () {
        console.log('異步加載 ' + jsScriptUrl + ' 耗時：' + (new Date().getTime() - startAt) + ' 毫秒');
        resolve();
      };
      targetWindow.document.body.appendChild(scriptTag);
    } else {
      console.log('無需加載 ' + jsScriptUrl + ' 耗時：' + (new Date().getTime() - startAt) + ' 毫秒');
      resolve();
    }
  });
} //加载脚本

export function datetimeFormat(dateValue, strFormat) {
  if (dateValue === undefined || dateValue === null || dateValue === "") {
    return " ";
  }

  var res = moment(dateValue).format(strFormat);

  if(res <= "1900-01-01" && strFormat == "YYYY-MM-DD")
    res = "";

  return res;
}

//時間差，strFormat：years、months、weeks、days、hours、minutes 和 seconds
export function datetimeDiff(dateStart, dateEnd, strFormat) {
  if (dateStart === undefined || dateStart === null || dateStart === "") {
    return " ";
  }
  if (dateEnd === undefined || dateEnd === null || dateEnd === "") {
    return " ";
  }
  var startMoment = moment(dateStart);
  var endMoment = moment(dateEnd);
  return endMoment.diff(startMoment, strFormat);
}

//日期比較 dateStart < dateEnd 返回true, 否則 false
export function datetimeCompare(dateStart, dateEnd) {
  if (dateStart === undefined || dateStart === null || dateStart === "") {
    return false;
  }
  if (dateEnd === undefined || dateEnd === null || dateEnd === "") {
    return false;
  }
  var startMoment = moment(dateStart);
  var endMoment = moment(dateEnd);
  return startMoment < endMoment;
}

//打開客戶資料Tab
export function OpenCustInfo(fromEle, code, shop) {
  var key = "Cust_info" + code + "_" + shop;
  var label = "客戶資料" + code + "/" + shop;
  key = key.replace(/\//g, "_");
  var item = {
      path: key,
      name: key,
      label: label,
      icon: "s-home",
      meta: {
          istrun: true // 默认隐藏路由
      },
      url: "Cust_info/Cust_info_view",
      acode: "YSAEDVGORL",
  };

  var menus = JSON.parse(localStorage.getItem("menu")) || fromEle.$store.state.tab.menu;
  var exists = menus.filter(t => t.name == key);
  if (exists.length == 0) {
      item.component = () => dynamicRouteComponent(import(`@/views/rms86/${item.url}`), item.name);

      //新建路由
      menus.push(item);
      fromEle.$store.commit("setMenu", menus);
      var allRoutes = fromEle.$router.getRoutes();
      if(allRoutes.find(t=>t.name == item.name) == null )
        fromEle.$router.addRoute("main", item);

      Open_Tab(key, label, "V", null, { start32_code: code, start32_shop: shop }, null, fromEle);
  }
  else {
      //通過父容器調用 commonTag的方法 changeMenu
      var pContainer = fromEle.$parent;
      while (pContainer.$options.name != "mainComponent") {
          pContainer = pContainer.$parent;
      }

      var tags = fromEle.$store.state.tab.tabList;
      var index = tags.findIndex((val) => val != null && val.name === item.name);
      if (index >= 0) {
          //切換到客戶Tab
          pContainer.$refs.Tabs.changeMenu(item);
      }
      else {
          var jobkey = "Cust_info_job" + code + "_" + shop;
          jobkey = jobkey.replace(/\//g, "_");
          index = tags.findIndex((val) => val != null && val.name === jobkey);
          if (index >= 0) {
              //切換到客戶Job錄入Tab
              var CustJobItem = menus.filter(t => t.name == jobkey);

              pContainer.$refs.Tabs.changeMenu(CustJobItem[0]);
          }
          else {
            fromEle.$store.commit("closeTag", { item: item, type: 1 });
            Open_Tab(key, label, "V", null, { start32_code: code, start32_shop: shop }, null, fromEle);
          }
      }
  }
}

export function getFirstWeekOfMonth(date) {
  // 创建传入日期的副本
  var d = new Date(date);
  // 将日设置为0，这将设置为该月的第一天
  d.setDate(1);
  // 获取该月第一天的星期
  var dayOfWeek = d.getDay();
  // 中國習慣，一周從星期一開始，星期天結束
  dayOfWeek -= 1;
  if(dayOfWeek < 0) dayOfWeek = 6;
  d.setDate(d.getDate() - dayOfWeek);
  return d;
}

export function getLastWeekOfMonth(date) {
  // 创建传入日期的副本
  var d = new Date(date);
  // 设置为该月的第一天
  d.setDate(1);
  // 下月第一天
  d.setMonth(d.getMonth() + 1);
  // 获取下月第一天的星期
  var dayOfWeek = d.getDay();
  // 中國習慣，一周從星期一開始，星期天結束
  if(dayOfWeek == 0) dayOfWeek = 7;
  d.setDate(d.getDate() - dayOfWeek);
  return d;
}

let _this = null;
export function receive(vm) {
	_this = vm;
}
export function getVm() {
  return _this;
}